module.exports = __webpack_public_path__ + "img/waistband buttons quantity.dac983e2.png";